import React from 'react';
import { Tabs, Typography, Card } from 'antd';
import TickerSearch from "../../components/TickerSearch/TickerSearch";
import EtfCollection from "./components/EtfCollection";
import EtfTemplates from "./EtfTemplates";
import EtfChord from "../../components/Tickers/EtfChord";
import EtfIntersections from './components/EtfIntersections';
import EtfCumulativeLineChart from "../../components/Tickers/EtfCumulativeLineChart";
import NivoHeatChart, { transformDataForNivoHeatMap } from "../../charts/nivo/NivoHeatChart";
import NavTrail from "../../layouts/NavTrail";
import useEtfMatrix from "./useEtfMatrix";

const { TabPane } = Tabs;

const ETFMatrix = ({ onReset, dropdownItems }) => {
    const {
        selectedTickers,
        showSearch,
        filters,
        positions,
        etfColors,
        overlapData,
        filteredPositions,
        handleTickersSubmit,
        handleRemoveTicker,
        handleReset,
        handleAddETFsClick,
        handleSelectGroup,
        addTickerToSearch,
        removeTickerFromSearch,
        clearTickersFromSearch,
        setShowSearch,
    } = useEtfMatrix();

    return (
        <div>
            <NavTrail items={[{ label: "ETF Matrix" }]} />
            {selectedTickers.length === 0 && !showSearch && (
                <EtfTemplates onSelectGroup={handleSelectGroup} />
            )}

            {showSearch && (
                <TickerSearch
                    onTickersSubmit={handleTickersSubmit}
                    closeSearch={() => { setShowSearch(false); }}
                    types={['etf']}
                />
            )}

            {selectedTickers.length > 0 && !showSearch && (
                <Tabs defaultActiveKey="1" type="card" centered={true} className={'pt-3'}>
                    <TabPane tab="Overview" key="1">
                        <EtfCollection
                            selectedTickers={selectedTickers}
                            positions={filteredPositions}
                            onRemove={handleRemoveTicker}
                            filters={filters}
                            etfColors={etfColors}
                            addTickerToSearch={addTickerToSearch}
                            removeTickerFromSearch={removeTickerFromSearch}
                            clearTickersFromSearch={clearTickersFromSearch}
                            addEtfs={handleAddETFsClick}
                            removeEtfs={handleReset}
                        />
                    </TabPane>
                    <TabPane tab={'Overlap'} key={'3'}>
                        <Tabs centered={true}>
                            <TabPane key={'1'} tab={'Overlap Diagram'}>
                                <EtfChord parents={positions} />
                            </TabPane>
                            <TabPane key={'2'} tab={'Heat Chart'}>
                                <Card bordered={false}>
                                    <div style={{ height: '80vh', width: '80vw', padding: '50px', margin: 'auto' }}>
                                        <NivoHeatChart
                                            minValue={0}
                                            maxValue={100}
                                            data={transformDataForNivoHeatMap(overlapData)}
                                            keys={overlapData.map(x => x.x)}
                                            labelColor={'#FCFF94'}
                                            labelSize={14}
                                            showUpperAxis={false}
                                        />
                                    </div>
                                </Card>
                            </TabPane>
                        </Tabs>
                    </TabPane>
                    <TabPane tab={'Intersections'} key={'5'}>
                        {positions && <EtfIntersections positions={positions} />}
                    </TabPane>
                    <TabPane tab={<Typography.Text><Typography.Text style={{ color: 'red', fontWeight: '600' }}>NEW</Typography.Text> ETF Fills</Typography.Text>} key={'4'}>
                        <div style={{ width: '90vw', margin: 'auto' }} className={'p-3'}>
                            <EtfCumulativeLineChart etfs={Object.values(positions)} />
                        </div>
                    </TabPane>
                </Tabs>
            )}
        </div>
    );
};

export default ETFMatrix;
